import React from 'react';
import PropTypes from 'prop-types';
import Currency from './tools/currency';
import genericHelpers from './generic-helpers';

function ProductWasPrice(props) {
  const { was_price: wasPrice, set_size: setSize, price } = props;

  const updatedWasPrice = []
    .concat(wasPrice)
    .filter(Boolean)
    .reduce((memo, wp) => {
      if (wp.quantity <= (setSize || 1)) {
        return wp;
      }

      return memo;
    }, {});

  const isValid = genericHelpers.isWasPriceValid({
    was_price: updatedWasPrice,
    price,
  });

  return isValid ? (
    <span className="was-price">{Currency.format(updatedWasPrice.value)}</span>
  ) : null;
}

ProductWasPrice.propTypes = {
  price: PropTypes.number,
  set_size: PropTypes.number,
  was_price: PropTypes.arrayOf(
    PropTypes.shape({
      end_date: PropTypes.string,
      quantity: PropTypes.number,
      value: PropTypes.number,
      start_data: PropTypes.string,
    })
  ),
};

ProductWasPrice.defaultProps = {
  price: null,
  set_size: null,
  was_price: null,
};

export default ProductWasPrice;
